import React, { useEffect, useState } from "react"
import {
  generatePath,
  Link,
  Redirect,
  Route,
  Switch,
  withRouter,
} from "react-router-dom"
import * as routes from "../../../../../library/constants/routes"
import { KNOWMIX } from "../../../../../library/constants/routes"
import Loader from "../../../../../components/ui/loader"
import logoDefault from "../../../../../assets/img/product.svg"
import VerticalMenu from "../../../../../components/ui/verticalMenu"
import { bindActionCreators } from "redux"
import {
  clearCurrentKnowmix,
  clearStepsList,
  getKnowmix,
  stepsList,
  updateKnowmix,
} from "../../../../../library/store/actions/creators/knowmixCreators"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import KnowmixSettingsMain from "./knowmixSettingsMain/knowmixSettingsMain"
import KnowmixSettingsSteps from "./knowmixSettingsSteps/knowmixSettingsSteps"
import KnowmixSettingsExaminers from "./knowmixSettingsExaminers/knowmixSettingsExaminers"
import KnowmixSettingsPublic from "./knowmixSettingsPublic/knowmixSettingsPublic"
import getErrorText from "../../../../../library/constants/errorTypes"
import KnowmixSettingsUknows from "./knowmixSettingsKnowmeets/knowmixSettingsKnowmeets"
import KnowmixSettingsMembers from "./knowmixSettingsMembers/knowmixSettingsMembers"
import KnowmixSettingsStepUknows from "./knowmixSettingsKnowmeets/knowmixSettingsStepKnowmeets"

const redirectErrors = [23000, 23001, 23002, 20004]

const KnowmixSettings = (props) => {
  const [dataReceived, setDataReceived] = useState(false)
  const [redirect, setRedirect] = useState(false)

  useEffect(() => {
    getKnowmix()

    return () => props.clearStepsList()
  }, [])

  const getKnowmix = async () => {
    try {
      const data = await props.getKnowmix({
        id: parseInt(props.match.params.knowmixId),
      })

      if (!(data.is_admin || data.is_teacher)) {
        return props.history.replace(
          generatePath(KNOWMIX, { knowmixId: data.id })
        )
      }

      await getStepsList()
      setDataReceived(true)
    } catch ({ error }) {
      if (redirectErrors.includes(error.code)) {
        setRedirect(true)
      } else {
        props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
      }
    }
  }

  const getStepsList = async () => {
    try {
      await props.stepsList({ id: parseInt(props.match.params.knowmixId) })
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  const routeParam = { knowmixId: props.match.params.knowmixId }

  const hideMainSettingsMenuChildren = ![
    routes.KNOWMIX_SETTINGS,
    routes.KNOWMIX_SETTINGS_STEPS,

    routes.KNOWMIX_SETTINGS_EXAMINERS,
  ].includes(props.match.path)

  const hideMembersSettingsMenuChildren = ![
    routes.KNOWMIX_SETTINGS_MEMBERS,
    routes.KNOWMIX_SETTINGS_ADD_MEMBERS,
  ].includes(props.match.path)

  const hideKnowmeetSettingsMenuChildren = ![
    routes.KNOWMIX_SETTINGS_UKNOWS,
    routes.KNOWMIX_SETTINGS_STEP_UKNOWS,
  ].includes(props.match.path)

  const menuItems = [
    {
      path: generatePath(routes.KNOWMIX_SETTINGS, routeParam),
      type: "parent",
      label: "Settings",
      markAsActive: false,
    },
    {
      path: generatePath(routes.KNOWMIX_SETTINGS, routeParam),
      type: "child",
      label: "Main information",
      hidden: hideMainSettingsMenuChildren,
    },
    {
      path: generatePath(routes.KNOWMIX_SETTINGS_STEPS, routeParam),
      type: "child",
      label: "Steps",
      hidden: hideMainSettingsMenuChildren,
    },
    // {
    //   path: generatePath(routes.KNOWMIX_SETTINGS_EXAMINERS, routeParam),
    //   type: 'child',
    //   label: 'Examiners',
    //   hidden: hideMainSettingsMenuChildren,
    // },
    !!props.knowmix.currentKnowmix?.creator_group && {
      path: generatePath(routes.KNOWMIX_SETTINGS_UKNOWS, routeParam),
      type: "parent",
      label: "Meets",
      markAsActive: false,
    },
    !!props.knowmix.currentKnowmix?.creator_group && {
      path: generatePath(routes.KNOWMIX_SETTINGS_UKNOWS, routeParam),
      type: "child",
      label: "For course",
      hidden: hideKnowmeetSettingsMenuChildren,
    },
    !!props.knowmix.currentKnowmix?.creator_group && {
      path: generatePath(routes.KNOWMIX_SETTINGS_STEP_UKNOWS, routeParam),
      type: "child",
      label: "For steps",
      hidden: hideKnowmeetSettingsMenuChildren,
    },
    {
      path: generatePath(routes.KNOWMIX_SETTINGS_MEMBERS, routeParam),
      type: "parent",
      label: "Members",
    },
    // {
    //   path: generatePath(routes.KNOWMIX_SETTINGS_ADD_MEMBERS, routeParam),
    //   type: 'child',
    //   label: 'Add members',
    //   hidden: hideMembersSettingsMenuChildren,
    // },
    {
      path: generatePath(routes.KNOWMIX_SETTINGS_PUBLIC, routeParam),
      label: "Release",
    },
  ].filter(Boolean)

  if (
    redirect ||
    (dataReceived &&
      !(
        props.knowmix.currentKnowmix.is_creator ||
        props.knowmix.currentKnowmix.is_admin ||
        props.knowmix.currentKnowmix.is_teacher ||
        props.knowmix.currentKnowmix.is_product_admin
      ))
  ) {
    return <Redirect to={generatePath(routes.KNOWMIX, routeParam)} />
  }

  return (
    <div className="common-page__content">
      <main className="common-page__main">
        {dataReceived ? (
          (props.knowmix.currentKnowmix.is_creator ||
            props.knowmix.currentKnowmix.is_admin ||
            props.knowmix.currentKnowmix.is_teacher ||
            props.knowmix.currentKnowmix.is_product_admin) &&
          !props.knowmix.currentKnowmix.deleted ? (
            <Switch>
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_MAIN_INFO}
                component={KnowmixSettingsMain}
              />
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_STEPS}
                render={(props) => (
                  <KnowmixSettingsSteps
                    {...props}
                    getStepsList={getStepsList}
                  />
                )}
              />
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_UKNOWS}
                component={KnowmixSettingsUknows}
              />
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_STEP_UKNOWS}
                component={KnowmixSettingsStepUknows}
              />
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_EXAMINERS}
                component={KnowmixSettingsExaminers}
              />
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_MEMBERS}
                component={KnowmixSettingsMembers}
              />
              {/*<Route*/}
              {/*  exact*/}
              {/*  path={routes.KNOWMIX_SETTINGS_ADD_MEMBERS}*/}
              {/*  component={KnowmixSettingsAddMembers}*/}
              {/*/>*/}
              <Route
                exact
                path={routes.KNOWMIX_SETTINGS_PUBLIC}
                component={KnowmixSettingsPublic}
              />
            </Switch>
          ) : (
            <Redirect to={generatePath(routes.KNOWMIX, routeParam)} />
          )
        ) : (
          <Loader />
        )}
      </main>
      <aside className="common-page__sidebar">
        {dataReceived && (
          <>
            <div className="box aside-header">
              <Link
                to={generatePath(routes.KNOWMIX, {
                  knowmixId: props.knowmix.currentKnowmix.id,
                })}
                className="box__content aside-header__content"
              >
                <img
                  src={props.knowmix.currentKnowmix.photo || logoDefault}
                  className="aside-header__img"
                  alt=""
                />
                <div className="aside-header__info">
                  <div className="aside-header__name">
                    {props.knowmix.currentKnowmix.name}
                  </div>
                  <div className="aside-header__help">back to course</div>
                </div>
              </Link>
              {/*{props.knowmix.currentKnowmix.is_owned ? (*/}
              {/*  <Link*/}
              {/*    to={generatePath(routes.KNOWMIX, {*/}
              {/*      knowmixId: props.knowmix.currentKnowmix.id,*/}
              {/*    })}*/}
              {/*    className="box__content aside-header__content"*/}
              {/*  >*/}
              {/*    <img*/}
              {/*      src={props.knowmix.currentKnowmix.photo || logoDefault}*/}
              {/*      className="aside-header__img"*/}
              {/*      alt=""*/}
              {/*    />*/}
              {/*    <div className="aside-header__info">*/}
              {/*      <div className="aside-header__name">*/}
              {/*        {props.knowmix.currentKnowmix.name}*/}
              {/*      </div>*/}
              {/*      <div className="aside-header__help">back to KnowMix</div>*/}
              {/*    </div>*/}
              {/*  </Link>*/}
              {/*) : (*/}
              {/*  <Link*/}
              {/*    to={generatePath(routes.PRODUCT, {*/}
              {/*      productId: props.knowmix.currentKnowmix.product.id,*/}
              {/*    })}*/}
              {/*    className="box__content aside-header__content"*/}
              {/*  >*/}
              {/*    <img*/}
              {/*      src={*/}
              {/*        props.knowmix.currentKnowmix.product.image || logoDefault*/}
              {/*      }*/}
              {/*      className="aside-header__img"*/}
              {/*      alt=""*/}
              {/*    />*/}
              {/*    <div className="aside-header__info">*/}
              {/*      <div className="aside-header__name">*/}
              {/*        {props.knowmix.currentKnowmix.product.name}*/}
              {/*      </div>*/}
              {/*      <div className="aside-header__help">back to product</div>*/}
              {/*    </div>*/}
              {/*  </Link>*/}
              {/*)}*/}
            </div>
            {!!props.knowmix.currentKnowmix?.creator_group?.id && (
              <div className="box aside-header">
                <Link
                  to={generatePath(routes.GROUP_SETTINGS_KNOWMIX, {
                    groupId: props.knowmix.currentKnowmix.creator_group.id,
                  })}
                  target={"_blank"}
                  className="box__content aside-header__content"
                >
                  <div className="color-primary font-weight-500">
                    Open group courses
                  </div>
                </Link>
              </div>
            )}
          </>
        )}
        <VerticalMenu menuItems={menuItems} />
        {/*<Ads/>*/}
      </aside>
    </div>
  )
}

const mapStateToProps = ({ auth, knowmix }) => ({ auth, knowmix })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getKnowmix,
      updateKnowmix,
      stepsList,
      clearStepsList,
      clearCurrentKnowmix,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(withRouter(KnowmixSettings)))
